

let instance;

class Photos {
	static getInstance() {
		if (!instance) {
			instance = new Photos(document.getElementById("photosContainer"))
		}
		return instance

	}

	constructor(container) {
		this.container = container
		this.app = this.makeApp(container)
		this.isOpen = false;
	}

	makeApp(container) {

		let service = {
			serviceName: 'dev',
			originType: 'dev'
		}

		if (window.Config.production) {
			service = {
				serviceName: 'tistory',
				originType: 'daum'
			}
		}

		let app = new window.photos.App(container, Object.assign({
			menu: {
				main: [
					'crop',
					'size',
				]
			},
			lightOn: false,
            save: {
                type: 'image/jpeg',
                encoderOptions: 0.92
            }
		}, service))

		app.on('photos:edit:complete', (results) => {
			this.handleEditComplete(results[0].dataURL)
			this.hide()
		})

		app.on('photos:edit:cancel', () => {
			this.hide()
		})

		return app
	}

	show() {
		this.container.style.display = "block"
		this.isOpen = true
	}

	hide() {
		this.container.style.display = "none"
		this.callback = null
		this.isOpen = false
	}

	handleEditComplete(dataUrl) {
		if (this.callback) {
			this.callback(dataURItoBlob(dataUrl))
		}
	}

	open(url, callback) {
		this.show()
		this.app.open(url)
		this.callback = callback
	}
}

const dataURItoBlob = (dataURI) => {
	let byteString = atob(dataURI.split(',')[1])

	let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

	let ab = new ArrayBuffer(byteString.length)
	let ia = new Uint8Array(ab)
	for (let i = 0; i < byteString.length; i++) {
		ia[i] = byteString.charCodeAt(i)
	}

	return new Blob([ab], { type: mimeString })
}

export default Photos;
